import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/f23df84b201c18fe4e638aa6f8d16832.png"
              alt="Wake up Church Logo"
              className="h-12 w-auto"
            />
          </Link>

          {/* Navigation */}
          <nav className="flex items-center gap-8">
            <Link
              to="/"
              className={`text-base font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isActive('/')
                  ? 'text-[#8B1538]'
                  : 'text-[#2C2C2C] hover:text-[#8B1538]'
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`text-base font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isActive('/about')
                  ? 'text-[#8B1538]'
                  : 'text-[#2C2C2C] hover:text-[#8B1538]'
              }`}
            >
              About Us
            </Link>
            <Link
              to="/book"
              className={`text-base font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isActive('/book')
                  ? 'text-[#8B1538]'
                  : 'text-[#2C2C2C] hover:text-[#8B1538]'
              }`}
            >
              Book
            </Link>
            <Link
              to="/contact"
              className={`text-base font-semibold transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                isActive('/contact')
                  ? 'text-[#8B1538]'
                  : 'text-[#2C2C2C] hover:text-[#8B1538]'
              }`}
            >
              Contact Us
            </Link>
            <a
              href="https://www.amazon.com/Wake-up-Church-Patricia-Welsh/dp/1961017814"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#8B1538] text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#6B0F28] transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              Get the Book
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
